module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[101]100.496d8c0.woff2";